import cx from "classnames";
import { GatsbyImage, type IGatsbyImageData } from "gatsby-plugin-image";
import React, { type FC, type HTMLAttributes } from "react";
import { IconSprite } from "../IconSprite";
import { Link } from "../Link";
import * as styles from "./SidebarSignpost.module.scss";

interface Props extends HTMLAttributes<HTMLElement> {
	title: string;
	url: string;
	image?: IGatsbyImageData;
	summary?: string;
	linkText?: string;
}

export const SidebarSignpost: FC<Props> = ({
	title,
	url,
	image,
	summary,
	linkText = "View",
	className,
	...props
}) => {
	if (!url) {
		return null;
	}
	return (
		<Link
			to={url}
			className={cx(
				styles.component,
				className,
				styles[image ? "withImage" : "noImage"],
			)}
			{...props}
		>
			<div className={styles.imageTitleWrapper}>
				<h4>{title}</h4>
				{!!image && <GatsbyImage image={image} className={styles.image} />}
			</div>

			{!!summary && <p>{summary}</p>}
			{!!linkText && (
				<div className={styles.link}>
					<hr />
					<span>
						<span className={styles.linkText}>{linkText}</span>
						<IconSprite name="chevron-right" />
					</span>
				</div>
			)}
		</Link>
	);
};
export default SidebarSignpost;
